import { FC, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CourseEvent } from '../../models/CourseEvent';
import Form from 'react-bootstrap/Form';
import UserRegistrationEndpoint from '../../../api/endpoint/UserRegistrationEndpoint';

interface RegistrationProps {
    course: CourseEvent;
    show: boolean;
    onHide: () => void;
    initiateReload: () => void;
}

export const RegistrationModal: FC<RegistrationProps> = (props) => {
    const [validated, setValidated] = useState(false);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const handleSubmit = async (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else if(form.checkValidity() === true) {
            event.preventDefault();
            await handleRegister();
            
        }

        setValidated(true);
    };

    const handleRegister = async() => {
        try{
            const userRegistration = {
                course_event_id: props.course.course_event_id,
                full_name: fullName,
                email: email,
                phone_number: phone,
                attended_class_1: false,
                attended_class_2: false,
                survey_completed: false
            };

            const registerResult = await UserRegistrationEndpoint.Register(userRegistration);

            if(!registerResult || registerResult.errors.length > 0 || !registerResult.data){
                console.error('Error registering user.');
                setErrorMsg(registerResult.errors?.map((error) => error.message).join(', '));
            } else {
                props.onHide();
                props.initiateReload();
            }
        }
        catch(err) {
            console.error('Registration error: ' + (err instanceof Error ? err.message : String(err)));
            setErrorMsg('Registration error: ' + (err instanceof Error ? err.message : String(err)));
        }
    }

    return (
        <Modal
            show={props.show}
            size="lg"
            aria-labelledby="registration-title"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="registration-title">
                    Register for {props.course.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="register-name">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control type="text" required value={fullName} onChange={(e:any) => setFullName(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your full name.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="register-email">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" required value={email} onChange={(e: any) => setEmail(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your email.</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="register-phone">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" required value={phone} onChange={(e:any) => setPhone(e.target.value)}/>
                        <Form.Control.Feedback type="invalid">Please enter your phone number.</Form.Control.Feedback>
                    </Form.Group>
                    
                    <Modal.Footer>
                        <div className="text-danger">
                            {errorMsg}
                        </div>
                        <Button variant="secondary" onClick={props.onHide}>Close</Button>
                        <Button variant="primary" className="text-light" type="submit">Submit</Button>
                    </Modal.Footer>
                    
                </Form>
            </Modal.Body>
            
        </Modal>
    )
}